export default "/assets/images/app-showcase-05-sm.jpg?afdc69640d865e5ea3fd017248002bee";